import { canUseDom } from '@actr/utilities/src/dom';
import { getStorage, setStorage, STORAGES } from '@actr/utilities/src/local-storage';

import config from '../configs';

export const HOTEL_ACCESS_TOKEN_PARAM = 'access_token';

const HOTEL_ACCESS_STORAGE_KEY = 'hotelAccessToken';

export function captureHotelAccessFromUrl(): void {
  if (!canUseDom || !config.hotel.accessToken) {
    return;
  }

  const url = new URL(window.location.href);
  const token = url.searchParams.get(HOTEL_ACCESS_TOKEN_PARAM);
  if (!token) {
    return;
  }

  if (token === config.hotel.accessToken) {
    setStorage(HOTEL_ACCESS_STORAGE_KEY, token, [STORAGES.SESSION]);
  }
  url.searchParams.delete(HOTEL_ACCESS_TOKEN_PARAM);

  window.history.replaceState(null, '', url);
}

export function hasHotelAccess(): boolean {
  if (!canUseDom || !config.hotel.accessToken) {
    return false;
  }

  return getStorage(HOTEL_ACCESS_STORAGE_KEY, [STORAGES.SESSION]) === config.hotel.accessToken;
}
